import n from "./_Uint8Array.js";
function o(t) {
  var e = new t.constructor(t.byteLength);
  return new n(e).set(new n(t)), e;
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneArrayBuffer.js
// module id = 442
// module chunks = 41